import {
    GET_SERVICEABLE_AREA,
    GET_ALL_SERVICEABLE_AREAS,
    GET_SERVICEABLE_AREA_REQUEST,
    CREATE_SERVICEABLE_AREA,
    UPDATE_SERVICEABLE_AREA,
    DELETE_SERVICEABLE_AREA,
    CLEAR_SERVICEABLE_AREA,
    SERVICEABLE_AREA_ERROR,
    SERVICEABLE_AREA_LOADING
} from '../actions/types';

const initialState = {
    serviceableAreas: [],
    serviceableArea: null,
    loading: false,
    error: null
};

export default function serviceableAreaReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SERVICEABLE_AREA_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_SERVICEABLE_AREAS:
            return {
                ...state,
                serviceableAreas: payload,
                loading: false,
                error: null
            };

        case GET_SERVICEABLE_AREA_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_SERVICEABLE_AREA:
            return {
                ...state,
                serviceableArea: payload,
                loading: false,
                error: null
            };

        case CREATE_SERVICEABLE_AREA:
            return {
                ...state,
                serviceableAreas: [...state.serviceableAreas, payload],
                loading: false,
                error: null
            };

        case UPDATE_SERVICEABLE_AREA:
            return {
                ...state,
                serviceableAreas: state.serviceableAreas.map(area =>
                    area._id === payload._id ? payload : area
                ),
                serviceableArea: payload,
                loading: false,
                error: null
            };

        case DELETE_SERVICEABLE_AREA:
            return {
                ...state,
                serviceableAreas: state.serviceableAreas.filter(area => area._id !== payload),
                loading: false,
                error: null
            };

        case CLEAR_SERVICEABLE_AREA:
            return {
                ...state,
                serviceableArea: null,
                error: null
            };

        case SERVICEABLE_AREA_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        default:
            return state;
    }
}
